<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import SummaryIcon from '../icons/SummaryIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'

  const hasSummary = $derived(
    (videoStore.state.mediaDescriptor?.summaryEntries || []).length > 0,
  )

  async function handleSummaryButtonClick() {
    const summary = await videoStore.state.mediaDescriptor?.getSummary(
      videoStore.state.mediaDescriptor?.summaryEntries[0],
    )
    videoStore.setCurrentSummary(
      summary
        ? {
            ...summary,
            language: videoStore.state.mediaDescriptor!.summaryEntries[0]?.lang,
          }
        : null,
      videoStore.state.isPlaying,
    )
    videoStore.state.videoController?.pause()
  }
</script>

<ControlBarButton
  hidden={!hasSummary}
  onclick={() => handleSummaryButtonClick()}
  tooltip={translationsStore.state.summary}
>
  <SummaryIcon />
</ControlBarButton>
